import { useLocation } from "wouter";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useQuinzenas } from "@/hooks/use-equipe";

/**
 * Aviso proativo: sem quinzena ABERTA, qualquer tarefa registrada seria recusada pelo
 * servidor (409 SEM_QUINZENA) e — antes do fix — sumiria da folha. Mostra o atalho para
 * o Financeiro para criar a quinzena antes de o erro acontecer. Mobile-first: 1 clique.
 */
export function SemQuinzenaBanner() {
  const { data: quinzenas, isLoading } = useQuinzenas();
  const [, setLocation] = useLocation();

  if (isLoading || !quinzenas) return null;
  if (quinzenas.some(q => q.status === "ABERTA")) return null;

  return (
    <div className="flex items-center gap-3 rounded-lg border border-atencao/30 bg-atencao-suave px-4 py-3 text-sm text-atencao">
      <AlertTriangle className="h-5 w-5 shrink-0 text-atencao" />
      <span className="flex-1">
        Nenhuma quinzena aberta — crie a quinzena atual no Financeiro antes de registrar tarefas.
      </span>
      <Button
        size="sm"
        variant="outline"
        className="shrink-0 border-atencao/30 hover:bg-atencao-suave"
        onClick={() => setLocation("/equipe/financeiro")}
      >
        Abrir Financeiro
      </Button>
    </div>
  );
}
